<div class="container-fluid mt-4 p-4 bg-white rounded-4 shadow-sm">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <div class="d-flex align-items-center gap-3">
      <h4 class="m-0 fw-bold text-dark d-flex align-items-center">
        <i class="bi bi-calendar3 me-2 text-primary"></i>
        {{ title }}
      </h4>
      <div class="btn-group shadow-sm rounded-3 overflow-hidden">
        <button class="btn btn-outline-primary border-0" (click)="goToPrevious()" title="Anterior">
          <i class="bi bi-chevron-left">&larr;</i>
        </button>
        <button class="btn btn-outline-primary border-0 px-3 fw-medium" (click)="goToToday()">
          Hoje
        </button>
        <button class="btn btn-outline-primary border-0" (click)="goToNext()" title="Próximo">
          <i class="bi bi-chevron-right">&rarr;</i>
        </button>
      </div>
    </div>

    <div class="btn-group shadow-sm rounded-3 overflow-hidden">
      <button class="btn px-3 fw-medium border-0" [ngClass]="viewMode === 'dia' ? 'btn-primary' : 'btn-outline-primary'" (click)="setViewMode('dia')">Dia</button>
      <button class="btn px-3 fw-medium border-0" [ngClass]="viewMode === 'semana' ? 'btn-primary' : 'btn-outline-primary'" (click)="setViewMode('semana')">Semana</button>
      <button class="btn px-3 fw-medium border-0" [ngClass]="viewMode === 'mes' ? 'btn-primary' : 'btn-outline-primary'" (click)="setViewMode('mes')">Mês</button>
    </div>
  </div>

  <!-- Visão Mensal -->
  <div *ngIf="viewMode === 'mes'" class="table-responsive">
    <table class="table text-center mb-0 calendar-table">
      <thead>
      <tr>
        <th>Dom</th>
        <th>Seg</th>
        <th>Ter</th>
        <th>Qua</th>
        <th>Qui</th>
        <th>Sex</th>
        <th>Sáb</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let week of weeks">
        <td *ngFor="let dayObj of week" [class.today]="isToday(dayObj)" [class.empty]="!dayObj" class="calendar-day" (click)="onDiaClick(dayObj)">
          <div *ngIf="dayObj" class="d-flex flex-column h-100 w-100">
            <span class="day-number">{{ dayObj.day }}</span>
            <div class="event-container" (click)="$event.stopPropagation()">
              <div *ngFor="let evento of getEventosFiltrados(dayObj.dataComparacao)" class="event-item">
                <a [routerLink]="['/juridico/tarefa/detalhes', evento.id]" class="text-decoration-none" [title]="evento.descricao">
                  <span class="event-time">{{ evento.hora }}</span>
                  <span class="event-desc">{{ evento.descricao }}</span>
                </a>
              </div>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

  <!-- Visão Semanal ou Diária -->
  <div *ngIf="viewMode !== 'mes'" class="row g-3">
    <div *ngFor="let dayObj of days" [ngClass]="viewMode === 'semana' ? 'col' : 'col-md-8 mx-auto'" (click)="onDiaClick(dayObj)">
      <div class="card h-100 border-0 shadow-sm rounded-3 overflow-hidden" [class.ring-primary]="isToday(dayObj)" style="cursor: pointer;">
        <div class="card-header border-0 d-flex justify-content-between align-items-center py-3 px-3" [ngClass]="isToday(dayObj) ? 'bg-primary-subtle' : 'bg-light'">
          <span class="fw-bold text-uppercase small tracking-wider" [class.text-primary]="isToday(dayObj)">{{ dayObj.dayName }}</span>
          <span class="badge rounded-pill px-3 py-2" [ngClass]="isToday(dayObj) ? 'bg-primary text-white' : 'bg-secondary-subtle text-dark'">{{ dayObj.day }}</span>
        </div>
        <div class="card-body p-3 day-view-body">
          <div *ngFor="let evento of getEventosFiltrados(dayObj.dataComparacao)" class="event-card mb-3 p-3 rounded-3 shadow-sm bg-white border-start border-4 border-primary" (click)="$event.stopPropagation()">
            <a [routerLink]="['/juridico/tarefa/detalhes', evento.id]" class="text-decoration-none text-dark">
              <div class="d-flex align-items-center mb-2">
                <i class="bi bi-clock-fill small me-2 text-primary"></i>
                <span class="fw-bold small text-primary">{{ evento.hora }}</span>
              </div>
              <div class="small fw-medium text-dark text-truncate-2">{{ evento.descricao }}</div>
            </a>
          </div>
          <div *ngIf="getEventosFiltrados(dayObj.dataComparacao).length === 0" class="text-center text-muted small py-5">
            <i class="bi bi-calendar-x d-block fs-2 mb-2 opacity-25"></i>
            Sem tarefas para este dia
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
